import React from "react";
import { Provider } from "./src/components/ui/provider";
export const wrapRootElement = ({ element }) => <Provider>{element}</Provider>;

const onRouteUpdate = () => {};

export { onRouteUpdate };
